import { SidebarIconProps } from "../../../types";

export default function MyProjectsIcon({ collapsed }: SidebarIconProps) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.75 9.25H11.75M6.75 6.75H11.75M4.25 1.125V14.875M1.75 1.125H14.25C14.5952 1.125 14.875 1.40482 14.875 1.75V14.25C14.875 14.5952 14.5952 14.875 14.25 14.875H1.75C1.40482 14.875 1.125 14.5952 1.125 14.25V1.75C1.125 1.40482 1.40482 1.125 1.75 1.125Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
